import * as XLSXRead from "xlsx";
import { matchIscrittiPresenza } from "./parseReportIF";

// Intestazioni accettate per il file iscritti (confronto case-insensitive, spazi ignorati)
const ALIAS = {
  "First Name": ["first name", "firstname", "nome"],
  "Last Name": ["last name", "lastname", "cognome"],
  "Email": ["email", "e-mail", "mail", "indirizzo email", "indirizzo e-mail"],
};

function normalizzaIntestazione(h) {
  return String(h || "").toLowerCase().replace(/\s+/g, " ").trim();
}

// Riporta ogni riga alle chiavi standard "First Name" / "Last Name" / "Email"
export function normalizzaIscritti(righe) {
  if (!righe.length) return [];
  const colonne = Object.keys(righe[0]);
  const mappa = {};
  Object.entries(ALIAS).forEach(([std, alias]) => {
    const trovata = colonne.find((c) => alias.includes(normalizzaIntestazione(c)));
    if (trovata) mappa[std] = trovata;
  });
  if (!mappa["First Name"] || !mappa["Last Name"]) {
    throw new Error(
      `Nel file iscritti non trovo le colonne nome/cognome (attese "First Name"/"Last Name" o "Nome"/"Cognome"). ` +
      `Colonne presenti: ${colonne.join(", ")}`
    );
  }
  return righe.map((r) => ({
    "First Name": String(r[mappa["First Name"]] ?? "").trim(),
    "Last Name": String(r[mappa["Last Name"]] ?? "").trim(),
    "Email": mappa["Email"] ? String(r[mappa["Email"]] ?? "").trim() : "",
  })).filter((r) => r["First Name"] || r["Last Name"]);
}

export function leggiIscritti(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const wb = XLSXRead.read(new Uint8Array(e.target.result), { type: "array" });
        const righe = XLSXRead.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { defval: "" });
        resolve(normalizzaIscritti(righe));
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}

function titleCase(s) {
  return String(s || "").trim().toLowerCase().replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1));
}

/**
 * Abbina i partecipanti del report Teams agli iscritti: prima per email (esatta),
 * poi per nome con la stessa logica del Report IF (Nome Cognome / Cognome Nome / sottoinsieme di parole).
 * Restituisce per ogni partecipante { nomeIscritto, cognomeIscritto, emailIscritto } oppure null se non trovato.
 */
export function abbinaIscritti(partecipanti, iscritti) {
  const perEmail = new Map();
  iscritti.forEach((isc) => {
    const e = isc.Email.toLowerCase();
    if (e && !perEmail.has(e)) perEmail.set(e, isc);
  });

  // matchIscrittiPresenza ricade sullo split euristico se non trova nessuno:
  // un abbinamento per nome è valido solo se la coppia nome/cognome esiste davvero tra gli iscritti
  const coppie = new Set(iscritti.map((isc) => `${titleCase(isc["First Name"])}|${titleCase(isc["Last Name"])}`));
  const perNome = matchIscrittiPresenza(
    partecipanti.map((p) => ({ nome: p.nome || "", email: "" })),
    iscritti
  );

  return partecipanti.map((p, i) => {
    const perMail = p.email ? perEmail.get(String(p.email).trim().toLowerCase()) : null;
    if (perMail) {
      return {
        nomeIscritto: titleCase(perMail["First Name"]),
        cognomeIscritto: titleCase(perMail["Last Name"]),
        emailIscritto: perMail.Email.toLowerCase(),
      };
    }
    const m = perNome[i];
    if (!coppie.has(`${m.nome}|${m.cognome}`)) return null;
    return { nomeIscritto: m.nome, cognomeIscritto: m.cognome, emailIscritto: m.email || "" };
  });
}
